var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBelarus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60924 14.8407L4.87012 11.6855L6.60924 8.57983L8.34837 11.6855L6.60924 14.8407Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13073 14.8407L1.3916 11.6855L3.13073 8.57983L4.86985 11.6855L3.13073 14.8407Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60924 23.4203L4.87012 20.2651L6.60924 17.1594L8.34837 20.2651L6.60924 23.4203Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13073 23.4203L1.3916 20.2651L3.13073 17.1594L4.86985 20.2651L3.13073 23.4203Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3481 3.10581L7.85573 2.22656C6.9726 2.74981 6.14429 3.35562 5.3811 4.03337L6.60898 6.26094L8.3481 3.10581Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60898 25.7393L5.3681 27.9553C6.1306 28.6339 6.95835 29.2406 7.8411 29.7649L8.34817 28.845L6.60898 25.7393Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73912 20.1738V30.7278C11.6622 31.5463 13.778 31.9999 16 31.9999C22.8794 31.9999 28.7441 27.6579 31.0048 21.5651L9.73912 20.1738Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5652C31.648 19.8319 32 17.9571 32 16C32 7.1635 24.8365 0 16 0C13.7782 0 11.6622 0.453312 9.73912 1.27175V21.5653H31.0048V21.5652Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBelarus);
export default __webpack_public_path__ + "static/media/flag_belarus.a7cb4762f940376cff11811d69f3fd5d.svg";
export { ForwardRef as ReactComponent };